// Chart.js version decision (Task 1607): stay on v3.6 syntax. chart.js@^3.6.0
// and react-chartjs-2@^4 are already installed but currently unused (every
// chart in this app renders via react-google-charts; existing react-chartjs-2
// JSX in this folder is dead, commented-out code). No version bump — this
// redesign doesn't need any v4-only feature.

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  LineElement,
  PointElement,
  Tooltip,
  Legend,
} from "chart.js";

// react-chartjs-2@4 requires explicit Chart.js element/scale registration.
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  LineElement,
  PointElement,
  Tooltip,
  Legend
);

export const ACCENT = "#3b5bdb";
export const GRID_COLOR = "#eef1f8";

export const PALETTE = [
  "#3b5bdb",
  "#4f7cff",
  "#2bb673",
  "#e8a33d",
  "#e2574c",
  "#9b59b6",
  "#16a085",
  "#e84393",
  "#00b8d4",
  "#f39c12",
  "#7f8c8d",
  "#34495e",
];

export const baseOptions = {
  maintainAspectRatio: false,
  responsive: true,
  plugins: { legend: { display: false } },
};

// legend stays off here — CustomLegend (below the chart) is the single legend,
// avoids rendering both Chart.js's built-in legend and CustomLegend at once.
export const donutOptions = {
  ...baseOptions,
  cutout: "58%",
};

export const barOptions = (horizontal = false) => ({
  ...baseOptions,
  indexAxis: horizontal ? "y" : "x",
  scales: {
    x: { grid: { display: !horizontal, color: GRID_COLOR } },
    y: { grid: { color: GRID_COLOR } },
  },
});
